import { sortByDesc } from '../../../shared/utils/sortUtils.ts';
import { Tool } from '../../components/operation-dialog/operationDraft.ts';
import { Batch, Operation } from '../../types/sharedTypeImpl.ts';
import { countWorkdays } from '../../utils/countWorkdays.ts';
import { formatBrokenToolFrequency } from '../../utils/fieldFormats.ts';
import { countUnfixedUnscheduledToolChangesByTool } from '../../utils/toolChangeAlarms.ts';


interface Props {
    batch: Batch;
    batchOperations: Operation[];
    selectedTool: Tool | null;
    onToolSelected: (tool: Tool, toolOps: Operation[]) => void;
}

export function BrokenToolsPerTool({
    batch,
    batchOperations,
    selectedTool,
    onToolSelected,
}: Props) {

    const batchLengthDays = countWorkdays(batch.start, new Date());
    const alarmCounts = sortByDesc(
        countUnfixedUnscheduledToolChangesByTool(batchOperations),
        it => it.count
    );


    const handleRowClick = (toolVariant: string, toolNumber: string, toolOps: Operation[]) => {
        onToolSelected({ toolVariant, toolNumber }, toolOps);
    };

    const isSameTool = (a: Tool, b: Tool | null): boolean => {
        return a.toolVariant === b?.toolVariant && a.toolNumber === b?.toolNumber;
    }

    return (
        <table className='table--mid-width' style={{ marginTop: '16px' }} >
            <thead>
                <tr>
                    <th>Tool</th>
                    <th>Broken tools count</th>
                    <th>Interval (days)</th>
                </tr>
            </thead>
            <tbody>
                {alarmCounts.map(it => (
                    <tr
                        key={`${it.toolVariant}-${it.toolNumber}}`}
                        className={isSameTool(it, selectedTool) ? 'highlight--selected' : ''}
                        onClick={() => handleRowClick(it.toolVariant, it.toolNumber, it.relatedOperations)}
                    >
                        <td>{`${it.toolVariant} ${it.toolNumber}`}</td>
                        <td>{it.count}</td>
                        <td>{formatBrokenToolFrequency(it.count > 0 ? batchLengthDays / it.count : null)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
